import './scss/index.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';

import customHistory from './history';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
import { UserProvider } from './contexts/user-context/UserProvider';
import { CookiesProvider } from 'react-cookie';
import { MyThemeProvider } from './contexts/theme-context/ThemeProviderContext';
import { FlashMessageProvider } from './contexts/flash-messages-context/FlashMessageProvider';

const rootEl = document.getElementById('root');

let render = () => {
	ReactDOM.render(
		// react router dom
		<Router history={customHistory}>
			{/* MFA User context provider */}
			<UserProvider>
				{/* MFA cookies context provider */}
				<CookiesProvider>
					{/* MFA theme context provider */}
					<MyThemeProvider>
						{/* MFA Flash messages context provider */}
						<FlashMessageProvider>
							<App />
						</FlashMessageProvider>
					</MyThemeProvider>
				</CookiesProvider>
			</UserProvider>
		</Router>,
		rootEl
	);
};

if (module.hot) {
	module.hot.accept();
	// module.hot.accept('./app/App', () => {
	// 	setTimeout(render);
	// });
}

render();

// ReactDOM.render(
// 	<React.StrictMode>
// 		<App />
// 	</React.StrictMode>,
// 	document.getElementById('root')
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
